import renderResource from '../resource/render-resource'
import imageProperties from '../widgets/lib/image-properties'

const createQuery = () => {
  const releaseQuery = `...on Release {
    _id
    externalId
    type
    title
    episodeTitle
    shortFormInsight
    synopsis
    lang
    genre
    durationSeconds
    cutDurationSeconds
    mxfReleaseId
    bbfcReference
    releaseType
    version
    cutsSummary
    VMCutsInfo
    paperworkRemarks
    cast
    directors
    mediaType
    releaseDate
    releaseYear
    productionYear
    classification
    classificationDate
    rejectedDate
    rejectionExplanation
    rawLongFormInsights
    nonDefiningIssues
    visualAdviceLayer {
      overview {
        id
        title
        description
        strength
      }
      details {
        id
        title
        description
        strength
        hideStrengthIndicator
      }
    }
    sourceUri
    posterUri
    distributor
    mxfReleaseId
    trailerYoutubeId
    currentlyShowingInCinema
    embargoDate
    images {
      _751 {
        url
      }
    }
    primaryAsset {
      rawLongFormInsights
      shortFormInsight
      genre
      durationSeconds
      cutDurationSeconds
      mediaType
      releaseDate
      sourceUri
      version
      cutsSummary
      VMCutsInfo
      releaseType
      rejectionExplanation
      paperworkRemarks
      bbfcReference
      directors
      cast
      classificationDate
      nonDefiningIssues
    }
    features {
      title
      releaseDate
      classification
      slug
      durationSeconds
      mediaType
      distributor
      classificationDate
      classificationUse
      version
      cutsSummary
      VMCutsInfo
      rejectionExplanation
      paperworkRemarks
      rawLongFormInsights
      nonDefiningIssues
      shortFormInsight
      visualAdviceLayer {
        overview {
          id
          title
          description
          strength
        }
        details {
          id
          title
          description
          strength
          hideStrengthIndicator
        }
      }
    }
    videos {
      title
      releaseDate
      classification
      slug
      durationSeconds
      mediaType
      distributor
      classificationDate
      classificationUse
      version
      cutsSummary
      VMCutsInfo
      rejectionExplanation
      paperworkRemarks
      rawLongFormInsights
      shortFormInsight
      visualAdviceLayer {
        overview {
          id
          title
          description
          strength
        }
        details {
          id
          title
          description
          strength
          hideStrengthIndicator
        }
      }
      nonDefiningIssues
    }
    adverts {
      title
      releaseDate
      classification
      slug
      durationSeconds
      mediaType
      distributor
      classificationDate
      classificationUse
      version
      cutsSummary
      VMCutsInfo
      rejectionExplanation
      paperworkRemarks
      shortFormInsight
    }
    valueAddedMedia {
      title
      releaseDate
      classification
      slug
      durationSeconds
      mediaType
      distributor
      classificationDate
      classificationUse
      version
      cutsSummary
      VMCutsInfo
      rejectionExplanation
      paperworkRemarks
    }
    trailers {
      title
      releaseDate
      classification
      slug
      durationSeconds
      mediaType
      distributor
      classificationDate
      classificationUse
      version
      cutsSummary
      VMCutsInfo
      rejectionExplanation
      paperworkRemarks
      shortFormInsight
    }
    seasons {
      classification
      number
      episodes {
        title
        releaseDate
        classification
        slug
        durationSeconds
        classificationDate
        episodeTitle
        episode
        classificationUse
        version
        cutsSummary
        VMCutsInfo
        rejectionExplanation
        paperworkRemarks
        shortFormInsight
        synopsis
        visualAdviceLayer {
          overview {
            id
            title
            description
            strength
          }
          details {
            id
            title
            description
            strength
            hideStrengthIndicator
          }
        }
        nonDefiningIssues
      }
    }
    relatedArticles {
      _id
      headline
      shortHeadline
      fullUrlPath
      contentRating
      sell
      images {
        thumbnail_3x2_438 {
          ${imageProperties}
        }
      }
    }
  }`
  return renderResource(releaseQuery)
}

export default createQuery
